var generateComponentTheme = function generateComponentTheme(_ref) {
  var borders = _ref.borders,
    spacing = _ref.spacing,
    colors = _ref.colors,
    typography = _ref.typography;
  return {
    containerBorderWidth: borders.widthSmall,
    containerBorderColor: colors.tiara,
    seriesContainerMargin: spacing.small,
    seriesContainerRowMargin: spacing.medium,
    seriesSwatchMargin: spacing.small,
    seriesSwatchBackgroundColor: colors.electric,
    seriesLabelFontFamily: typography.fontFamily,
    seriesLabelFontSize: typography.fontSizeXSmall,
    seriesLabelColor: colors.textDarkest
  };
};
export default generateComponentTheme;